<template>
    <div class="success-page" id="print-area">
        <!-- 标题 -->
        <div class="title"> 签到成功</div>
        <div class="subtitle">您的照片信息已上传</div>
        <!-- <div class="positionBtns" @click="getLocation">获取定位</div> -->
        <!-- 头像展示 -->
        <div class="avatar-container">
            <img :src="userAvatar" alt="用户头像" class="user-avatar" />
        </div>

        <!-- 认证时间 -->
        <div class="certify-time">
            签到时间：{{ certifyTime }}
        </div>
        <div class="certify-time">
            当前时间：{{ nowTimeShow }}
        </div>
        <!-- 签名区域 -->
        <div class="signature-section">
            <div class="signature-area">
                <img v-if="signatureImage" :src="signatureImage" class="signature-image" alt="签名" />
            </div>
        </div>

        <!-- 按钮 -->

        <button class="print-button" @click="haPrint">打印</button>

    </div>
</template>

<script>
/* eslint-disable no-undef */
//import VConsole from 'vconsole';
import { firstApi } from '../http/api';

export default {
    name: 'overRitht',
    data() {
        return {
            userAvatar: '',
            certifyTime: '',
            signatureImage: '', // 保存签名图片
            showSignatureModal: false,
            isDrawing: false,
            certifyId: '',
            nowTimeShow: '',
            timeS: null,
            pageName: '认证'
        };
    },
    
    mounted() {
        this.certifyId = this.$route.query.certifyId;
        if (this.certifyId) {
            this.getUserAvatar();

            this.timeS = setInterval(() => {
                this.nowTimeShow = this.nowTime();
            }, 1000);
        }

        // try {
        //   const vConsole = new VConsole();
        //   console.log('vconsole 初始化成功', vConsole);
        //   // 强制显示 vconsole 面板
        //   setTimeout(() => {
        //     if (vConsole && typeof vConsole.show === 'function') {
        //       vConsole.show();
        //       console.log('vconsole 已显示');
        //     }
        //   }, 1000);

        // } catch (error) {
        //   console.error('vconsole 初始化失败:', error);
        // }
    },
    methods: {
        getUserAvatar() {
            firstApi.querySignSuccessExamSign({ certifyId: this.certifyId }).then(res => {
                console.log(res, '头像');
                if (res.code == 1) {
                    this.userAvatar = res.data.pictureUrl;
                    this.certifyTime = res.data.signDate;
                    this.signatureImage = res.data.signPictureUrl;
                } else if (res.code == 1001) {
                    localStorage.removeItem('token');
                    this.$router.push({
                        path: '/signin',
                    });
                } else {
                    this.userAvatar = '';

                }
            });
        },
        haPrint() {
            // 打印调用打印机
            // 小程序端使用 uni.printer
            const printArea = document.getElementById('print-area'); // 假设有一个ID为print-area的区域是要打印的
            const content = printArea.innerText || printArea.textContent;
            if (window.__wxjs_environment === 'miniprogram') {
                // 通过 postMessage 通知小程序执行打印
                // wx.miniProgram.postMessage({
                //     data: { action: 'print' },
                //     content
                // });
                const token = localStorage.getItem('token');
                // 可选：通知小程序关闭当前 web-view 页面 /pages/loding/loding
                wx.miniProgram.navigateTo({
                    url: `/pages/searchProint/searchProint?token=${token}`
                });
            } else {
                // 普通浏览器环境
                window.print();
            }
        },
        nowTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },














    },
    beforeDestroy() {
        clearInterval(this.timeS);
    }
};
</script>

<style scoped>
.success-page {
    display: flex;
    flex-direction: column;
    align-items: left;
    padding: 40px 20px;
    background-color: #f8f9fa;
    min-height: 100vh;
}

.title {
    font-weight: 800;
    font-size: 22px;
    color: #323233;
    margin-bottom: 8px;
}

.subtitle {
    font-size: 14px;
    color: #666;
    margin-bottom: 30px;
}

.positionBtns {
    position: fixed;
    top: 20px;
    right: 20px;
    border: 1px solid #ccc;
}

.avatar-container {
    width: 144px;
    height: 144px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.certify-time {
    font-weight: bold;
    font-size: 20px;
    color: #323233;
    margin-bottom: 30px;
    text-align: left;
}

.signature-section {
    width: 100%;
    max-width: 350px;
    margin-bottom: 30px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    text-align: left;
}

.signature-area {
    width: 100%;
    height: 176px;
    background-color: #f0f2f5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px dashed #ccc;
    position: relative;
    overflow: hidden;
}

.signature-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.signature-placeholder {
    font-size: 16px;
    color: #999;
    text-align: center;
}

.print-button {
    position: fixed;
    bottom: 50px;
    width: 330px;
    height: 40px;
    line-height: 40px;
    background: #4C7AF3;
    color: white;
    border: none;
    border-radius: 21px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.print-button:hover {
    background-color: #0056b3;
}

/* 签名板弹窗样式 */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.signature-modal {
    width: 90%;
    max-width: 400px;
    background: white;
    border-radius: 10px;
    overflow: hidden;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #eee;
}

.modal-header span {
    font-weight: bold;
    color: #333;
}

.close-button {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
}

.signature-canvas {
    width: 100%;
    height: 200px;
    background-color: #f9f9f9;
    touch-action: none;
}

.modal-footer {
    display: flex;
    justify-content: space-between;
    padding: 15px;
}

.clear-button,
.confirm-button {
    padding: 8px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.clear-button {
    background-color: #f0f2f5;
    color: #333;
}

.confirm-button {
    background-color: #007bff;
    color: white;
}
</style>